<div class="container-fluid padMob" style="padding-left: 10px; padding-right: 10px; background: rgb(248, 248, 248) !important; border-radius: 10px; background-color: #f8f8f8; {{(productDetials.TypeID != 6 || productDetials.bom.length > 0) && !isMobileView && productDetials.isMfg ? 'min-width: 1000px;' : 'max-width: 600px; border-radius: 10px;'}}">
    <div class="row HeadDiv">

        <!-- Wev View -->
        <div class="webView" style="width: 100%;">
            <!-- Header -->
            <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder divHeader"
                style="padding-bottom: 0px; padding-right: 0px; padding-top: 5px; padding-left: 10px; background: rgb(248, 248, 248) !important;">
                <div class="col-9" style="display: inline-block; padding-left: 0px;">
                    <h4 style="display: inline-block; word-break: break-all;">{{productDetials.productName}} 
                        <span *ngIf="productDetials.TypeID != 6" style="font-size: 16px; color: #777;margin-left: 5px;"> ({{productDetials.categoryName}} / {{productDetials.subCategoryName }})</span>
                        <span *ngIf="productDetials.TypeID == 6" style="font-size: 16px; color: #777;margin-left: 5px; word-break: break-all;"> (#{{productDetials.productCode}}) </span>
                    </h4>

                </div>
                <div class="col-3" style="display: inline-block; text-align: right; vertical-align: top;">
                    <span *ngIf="productDetials.TypeID == 6" class="darkBlueButton brdrRadius3" title="Edit Project Type" style="font-size: 15px; cursor: pointer; margin-right: 10px; padding: 2px 7px;" (click)="editProjectType()"> 
                        <i class="fa fa-pencil"></i>
                    </span>
                    <span *ngIf="right.InvMstrs" class="lableBtnGray brdrRadius3" title="Delete Item" style="margin-right: 10px; padding: 2px 9px; cursor: pointer;" (click)="deleteItem()">
                        <i class="fa fa-trash" aria-hidden="true" style="font-size: 16px"></i>
                    </span>
                    <span style="font-size: 22px; cursor: pointer; padding: 3px 10px !important; margin-top: 0px;"
                        class="webView closeMdl" (click)="goBack();">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </div>
            </div>

            <!-- Body -->
            <div class="col-md-12 col-12 col-sm-12 DivPad" style="padding: 0px;margin-bottom:{{(productDetials.TypeID != 6 ? productDetials.isMfg : productDetials.bom.length > 0) ? '15px !important' : '-10px !important'}}">
                <div class=" {{(productDetials.TypeID != 6 ? productDetials.isMfg : productDetials.bom.length > 0) ? 'col-md-6' : 'col-md-12'}} col-sm-12" style="display: inline-block;
                padding-left: {{(productDetials.TypeID != 6 ? productDetials.isMfg : productDetials.bom.length > 0) ? '' : '10px  !important'}}; padding-right: {{(productDetials.TypeID != 6 ? productDetials.isMfg : productDetials.bom.length > 0) ? '0px !important' : '10px  !important'}};">
                    <div *ngIf="productDetials.TypeID != 6" class="col-md-12 col-12 col-sm-12" style="padding: 0px;" >
                        <!-- Basic Data -->
                        <div  class="col-md-12 col-12 col-sm-12 brdrRadius3"  style="margin-top: 10px; padding: 10px 15px; margin-bottom: 5px; background-color: #fff; 
                        border: 1px solid #15304a; display: inline-block;">
                            <div style="color: #15304a; font-size: 16px; font-weight: bold;">
                                <span>Basic Details</span>
                                <span style="float: right;">
                                    <span *ngIf="right.InvMstrs"
                                    class="darkBlueButton brdrRadius3" 
                                    style="margin-right: 5px; font-size: 14px; cursor: pointer; padding: 7px 7px; border-radius: 3px;background: #15304a; color: white;font-weight: normal !important;"
                                    (click)="productDetials.isActiveStatus ? confirmStatusChange() : changeActiveStatus()">
                                <i [class]="productDetials.isActiveStatus ? 'fa fa-ban' : 'fa fa-check-circle'" style="margin-right: 5px;" class="darkBlueButton"></i>
                                {{ productDetials.isActiveStatus ? 'Mark Inactive' : 'Mark Active' }}
                                </span>

                                    <span *ngIf="right.InvMstrs" 
                                          class="darkBlueButton brdrRadius3" 
                                          style="font-size: 15px; cursor: pointer;" 
                                          (click)="openBasicDataEntry(mymodal);">
                                        <i class="fa fa-pencil"></i>
                                    </span>
                                </span>
                            </div>
                            <div>
                                <div class="col-md-12 col-12 col-sm-12"
                                    style="font-size: 12px; color: #777; padding-right: 0px; padding-left: 2px;">
                                    <span style="font-size: 14px;">
                                        <i class="fa fa-square"
                                        style="color: {{productDetials.TypeID == '1' ? '#4caf50' : productDetials.TypeID == '2' ? '#e88421' : productDetials.TypeID == '4' ? '#1f628e' : '#15304a'}};" title="{{productDetials.TypeID == '1' ? 'Product' : productDetials.TypeID == '2' ? 'Material' : productDetials.TypeID == '4' ? 'Assemblies' : 'Spares'}}"></i> {{productDetials.productCode}}
                                    </span>

                                </div>
                            </div>
                            <div style="margin-top: 8px;">
                                <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" [style.cursor]="stockCmp ? 'pointer' : 'default'" (click)="stockCmp ? editStock() : null" style="margin-bottom: 10px; margin-right: 5px; font-size: 12px; padding: 4px 10px;">
                                    Stock <span style="font-weight: 600;"> {{productDetials.stockQty}} {{productDetials.unitName}}</span>
                                    <i *ngIf="stockCmp" class="fa fa-pencil" style="color: #15304a; margin-left: 5px; font-weight: normal;" aria-hidden="true"></i>
                                    <span *ngIf ="productDetials.initQty && productDetials.initUnit" class="info-icon custom-tooltip" style="display: inline-flex; align-items: center; margin-left: 8px; height: 21px;">
                                        <i class="fa fa-info" style="vertical-align: middle;background: #15304a ;color: white ;width: 21px ;text-align: center; padding: 4px; border-radius: 3px; padding-bottom: 2px;"></i>
                                        <span class="tooltiptext">
                                        Initial qty {{productDetials.initQty}} {{productDetials.initUnit}} created on {{(productDetials.createdDT | date:'yyyy') === (today | date:'yyyy') ? (productDetials.createdDT | date:'MMM dd') : (productDetials.createdDT | date:'MM dd yyyy')}}
                                        </span>
                                    </span>
                                </span>
                               

                                <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; margin-bottom: 10px;font-size: 12px; padding: 4px 10px;">
                                    Lead Time <span style="font-weight: 600;">
                                        {{productDetials.leadTime}} days</span>
                                </span>

                                <span *ngIf="isRateView" class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px;margin-bottom: 10px;font-size: 12px; padding: 4px 10px;">
                                    Std Cost 
                                    <span *ngIf="myCurrency.code == 'INR'" style="font-weight: 600;"> ₹ {{productDetials.stdCost | lacFormat}}</span>                
                                    <span *ngIf="myCurrency.code != 'INR'" style="font-weight: 600;"> {{productDetials.stdCost | currency}}</span>
                                </span>

                                <span *ngIf="isRateView" class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; margin-bottom: 10px;font-size: 12px; padding: 4px 10px;">
                                    Std Price 
                                    <span *ngIf="myCurrency.code == 'INR'" style="font-weight: 600;"> ₹ {{productDetials.defPrice | lacFormat}}</span>
                                    <span *ngIf="myCurrency.code != 'INR'" style="font-weight: 600;"> {{productDetials.defPrice | currency}}</span>
                                </span>

                                <!-- <span class="brownBadge" style="margin-left: 5px; margin-bottom: 10px; cursor: pointer;font-size: 13px"  *ngIf="productDetials.isMfg && right.InvMstrs" (click) = "OpenUnit()">
                                    Edit Unit <span style="margin-left: 5px;"><i class="fa fa-pencil"></i></span>
                                </span>  -->

                                <!-- <span class="darkBlueBadge" style="margin-left: 5px; margin-bottom: 10px;">
                                    Source <span style="font-size: 18px; font-weight: 600;"> {{productDetials.sorce}}</span>
                                </span> -->
                            </div>

                            <div class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="display:inline-block; padding: 4px 10px; margin-top:5px;margin-right: 5px; font-size: 13px;" 
                            *ngFor="let x of tagList; let i = index">
                               <span >
                                   #{{x}}
                               </span>
                           </div>
                        </div>


                        <!-- Buy Product -->
                        <!-- <div class="col-md-4 col-12 col-sm-12 boxFlex" style="background-color: #4caf5008; padding-top: 10px; 
                        padding-bottom: 10px; margin-top: 10px; border-radius: 10px; border: 1px solid #4caf50; display: inline-block;" 
                        *ngIf="productDetials.isMfg">
                            <app-product-byproducts [ByproductData]="ByproductData"></app-product-byproducts>
                        </div> -->
                    </div>

                    <!-- Stages -->
                    <div class="brdrRadius3" style="background-color: #fff; width: 100%; height: {{ productDetials.TypeID != 6 ? '250px' : '443px' }}; overflow: auto;
                    padding: 10px 15px; margin-top: 10px; border: 1px solid #006400; display: inline-block; margin-right: 15px;"
                        *ngIf="productDetials.isMfg">
                        <app-stage-selection [stageData]="stageData" [isProjectType]="productDetials.TypeID == 6"></app-stage-selection>
                    </div>

                    <!-- <span class="btn-mdlClose closeMdl webView" style="margin-top: 10px; border-radius: 3px !important;" (click)="goBack();">
                        <i class="fa fa-close"></i>
                        <span style="padding-left: 5px;">Close</span>
                    </span> -->

                    <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                        <div class="btn-mdlClose brdrRadius3" style="padding: 6px 10px 6px 10px !important;" (click)="goBack();">
                            <i class="fa fa-close"></i> Close
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-12" style="display: inline-block;vertical-align: top;">
                   <!-- BOM -->
                    <div class="col-md-12 col-12 col-sm-12  brdrRadius3"
                        style="background-color: #FFF; padding-top: 10px; height: 443px;overflow: auto;
                       padding-bottom: 10px; margin-top: 10px; border: 1px solid #e88421; display: inline-block;"
                        *ngIf="productDetials.TypeID != 6 ? productDetials.isMfg : productDetials.bom.length > 0">
                        <app-product-bom [BOMData]="BOMData" [isProjectType]="productDetials.TypeID == 6"></app-product-bom>
                    </div>
                </div>
                <!-- Units -->
                <!-- <div class="col-md-4 col-12 col-sm-12 boxFlex" style="background-color: #1f628e08; padding-top: 10px; 
                        padding-bottom: 10px; margin-top: 10px; border-radius: 10px; border: 1px solid #1f628e; display: inline-block;" 
                        *ngIf="productDetials.isMfg">
                        <app-product-units></app-product-units>
                    </div> -->
            </div>
        </div>

        <!-- Mobile View -->
        <div class="mobView" style="width: 100%;">
            <!-- Header -->
            <div class="col-md-12 col-12 col-sm-12 pad0 divHeader"
                style="padding: 15px 0px;">
                <span (click)="goBack();" style="font-size: 22px; padding-right: 10px; display: inline-block; cursor: pointer;">
                    <i class="fa fa-chevron-left"></i>
                </span>
                <h4 style="display: inline-block; color: #555;">{{ productDetials.TypeID != 6 ? 'Item Detail' : 'Project Type Detail' }}</h4>
                <span  style="float: right;">
                    <!-- Edit Item -->
                    <span *ngIf="productDetials.TypeID != 6">
                        <span class="btn orangeButton" (click)="openBasicDataEntry(mymodal);" style="color:#fff; border-radius: 3px;">
                            <i class="fa fa-pencil" aria-hidden="true" style="font-size: 16px"></i> 
                        </span>
                    </span>
                    <!-- Edit Project Type -->
                    <span *ngIf="productDetials.TypeID == 6">
                        <span class="btn orangeButton" (click)="editProjectType()" style="color:#fff; border-radius: 3px;">
                            <i class="fa fa-pencil" aria-hidden="true" style="font-size: 16px"></i> 
                        </span>
                    </span>
                    <!-- Delete Item -->
                    <span>
                        <div class="lableBtnGray inLneBlk brdrRadius3" (click)="deleteItem()" style="margin-left: 10px; padding: 2px 9px;">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </div> 
                    </span>
                </span>
            </div>

            <div class="col-md-12 col-12 col-sm-12 DivPad" style="padding: 0px;">
                <!-- Basic Data -->
                <div class="col-md-12 col-12 col-sm-12" style="padding: 0px">
                    <!-- <div style="color: #E88421; font-size: 19px;">
                        <span>Basic Details</span>
                        <span style="float: right; font-size: 15px;"><i class="fa fa-pencil"></i></span>
                    </div> -->
                    <div>
                        <div class="col-md-12 col-12 col-sm-12 pad0">
                            <span style="color: #333; font-size: 18px;">
                                {{productDetials.productName}}
                            </span>
                        </div>
                        <div class="col-md-12 col-12 col-sm-12 font13 pad0"
                            style="color: #777;">
                            <span>
                                # {{productDetials.productCode}}
                            </span>
                            <!-- <span style="float: right; font-size: 12px; color: #E88421; cursor: pointer;"
                                (click)="openBasicDataEntry(mymodal);"><i class="fa fa-pencil"></i></span> -->
                        </div>
                    </div>
                    <div *ngIf="productDetials.TypeID != 6" style="margin-top: 10px;">
                        <span class="dtlBadge darkBlue" [style.cursor]="stockCmp ? 'pointer' : 'default'" (click)="stockCmp ? editStock() : null">
                            Stock 
                            <span class="dtlVal"> 
                                {{productDetials.stockQty}} {{productDetials.unitName}}
                                <i *ngIf="stockCmp" class="fa fa-pencil" style="color: #15304a; margin-left: 3px;" aria-hidden="true"></i>
                            </span>
                        </span>

                        <span class="dtlBadge darkBlue">
                            Lead Time <span class="dtlVal"> {{productDetials.leadTime}}
                                days</span>
                        </span>

                        <span *ngIf="isRateView" class="dtlBadge darkBlue">
                            Std Cost 
                            <span *ngIf="myCurrency.code == 'INR'" class="dtlVal"> ₹ {{productDetials.stdCost | lacFormat}}</span>
                            <span *ngIf="myCurrency.code != 'INR'" class="dtlVal"> {{productDetials.stdCost | currency}}</span>
                        </span>

                        <span *ngIf="isRateView" class="dtlBadge darkBlue">
                            Std Price 
                            <span *ngIf="myCurrency.code == 'INR'" class="dtlVal"> ₹ {{productDetials.defPrice | lacFormat}}</span>
                            <span *ngIf="myCurrency.code != 'INR'" class="dtlVal"> {{productDetials.defPrice | currency}}</span>
                        </span>
                        <div>
                            <span *ngIf="right.InvMstrs"
                            class="darkBlueButton brdrRadius3" 
                            style="margin-right: 5px; font-size: 14px; cursor: pointer; padding: 6px 12px !important; border-radius: 3px;background: #15304a; color: white;font-weight: normal !important;"
                            (click)="productDetials.isActiveStatus ? confirmStatusChange() : changeActiveStatus()">
                        <i [class]="productDetials.isActiveStatus ? 'fa fa-ban' : 'fa fa-check-circle'" style="margin-right: 5px;" class="darkBlueButton"></i>
                        {{ productDetials.isActiveStatus ? 'Mark Inactive' : 'Mark Active' }}
                        </span>
                    </div>

                        <!-- <span class="darkBlueBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            Source <span style="font-size: 18px; font-weight: 600;"> {{productDetials.sorce}}</span>
                        </span> -->
                    </div>
                </div>
                <!--Mark active/inactive button-->

                <!-- BOM -->
                 <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-bottom: 10px; margin-top: 10px;" *ngIf="productDetials.isMfg">
                    <div class="col-md-12 col-12 col-sm-12 dtlCard" *ngIf=" productDetials.bom.length == 0">
                        <div (click)="productDetials.TypeID != 6 ? fn_OpenWebBOM(productBOMModal) : ''">
                            <span style="color: #333; font-size: 15px !important; font-weight: 600;">BOM ({{productDetials.bom.length}})</span>
                            <span *ngIf="productDetials.TypeID != 6" class="addIcon">
                                <span  class="btn orangeButton" style="margin-top: -3px;
                                text-align: center;
                                justify-content: center !important;
                                display: flex;"><i class="zmdi zmdi-plus" style="vertical-align: top; margin-top: 2px;"></i></span>
                            </span>
                            <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="fn_OpenBOM();" class="mobView"><i class="zmdi zmdi-plus"></i></span> -->
                        </div>
                    </div>
                    <mat-accordion *ngIf="productDetials.bom.length > 0" style="margin-bottom: 10px;">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header style="padding: 10px; display: flex; align-items: center;">
                                <mat-panel-title style="align-items: center">
                                    <span style="color: #333; font-size: 15px !important; font-weight: 600;">BOM ({{productDetials.bom.length}})</span>
                                </mat-panel-title>
                                <mat-panel-description style="justify-content: flex-end; align-items: center">
                                    <span *ngIf="productDetials.TypeID != 6" class="addIcon" style="margin-right: 10px;" (click)="fn_OpenWebBOM(productBOMModal);">
                                        <i class="fa fa-plus" style="vertical-align: middle;"></i>
                                    </span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            
                            <div (click)="accordin.openAll()">
                                <div *ngFor="let i of productBOMList" style="padding-left: 0px;">
                                    <div style="margin-top: 8px; font-size: 15px; color: #777; display: flex;">
                                        <div style="display: inline-block; width: 74%; font-size: 15px; color: #333; line-height: 18px;">
                                            {{i.itemName}}
                                        </div>
                                        <div style="display: inline-block; width: 25%; text-align: right;">
                                            {{i.qty}} <span>{{i.unit}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                 </div>
                
                <!-- Byproduct & Scrap -->
                <div class="col-md-12 col-12 col-sm-12" style="background-color: #4caf5008; padding-top: 10px; padding-bottom: 10px; display: none; 
                margin-top: 10px;" *ngIf="productDetials.isMfg">
                    <div class="font13" style="color: #4caf50;">
                        <span>Byproducts & Scrap ({{productDetials.byProduct.length}})</span>
                        <span style="float: right; font-size: 20px; cursor: pointer;"
                            (click)="fn_OpenByproducts(productByproductModal);"><i class="zmdi zmdi-plus"></i></span>
                    </div>
                    <div style="margin-top: 8px; display: none;">
                        <!-- <div *ngFor="let i of productDetials.byProduct" style="padding-left: 10px;">
                            <div style="margin-top: 5px; font-size: 15px; color: #777;">
                                <div style="display: inline-block; width: 80%;">
                                    {{i.productName}}
                                </div>
                                <div style="display: inline-block; width: 19%; text-align: right;">
                                    {{i.qty}} {{i.unit}}
                                </div>
                            </div>
                            
                        </div> -->
                    </div>
                </div>

                <!-- Stages -->
                <div class="col-md-12 col-12 col-sm-12 pad0" *ngIf="productDetials.isMfg">
                    <div class="col-md-12 col-12 col-sm-12 dtlCard" *ngIf="productDetials.stages.length == 0">
                        <div style="color: #333; font-size: 15px !important; font-weight: 600;" (click)="productDetials.TypeID != 6 ? openNewStage(productStageModal) : ''">
                            <span>Stages ({{productDetials.stages.length == 0 ? 'Not Set' : productDetials.stages.length}})</span>
                            <!-- <span style="float: right; font-size: 20px; cursor: pointer;" class="webView" (click)="openStage();">
                                <i class="zmdi zmdi-plus"></i>
                            </span> -->
                            <span *ngIf="productDetials.TypeID != 6" class="addIcon">
                                <span span class="btn orangeButton" style="margin-top: -3px;
                                text-align: center;
                                justify-content: center !important;
                                display: flex
                            ;">  <i class="zmdi zmdi-plus" style="vertical-align: top; margin-top: 2px;"></i></span>
                            </span>
                        </div>
                    </div>
                    <mat-accordion *ngIf="productDetials.stages.length > 0" style="margin-bottom: 10px;">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header style="padding: 10px; display: flex; align-items: center;">
                                <mat-panel-title style="align-items: center">
                                    <span style="color: #333; font-size: 15px !important; font-weight: 600;">
                                        Stages ({{productDetials.stages.length == 0 ? 'Not Set' : productDetials.stages.length}})
                                    </span>
                                </mat-panel-title>
                                <mat-panel-description style="justify-content: flex-end; align-items: center">
                                    <span *ngIf="productDetials.TypeID != 6" class="addIcon" style="margin-right: 10px;" (click)="openNewStage(productStageModal);">
                                        <i class="fa fa-plus" style="vertical-align: middle;"></i>
                                    </span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div>
                                <div *ngFor="let s of productDetials.stages; let i = index" style="padding-left: 0px;">
                                    <div style="margin-bottom: 8px; font-size: 15px; color: #777;">
                                        <div style="display: inline-flex; font-size: 15px; color: #333;">
                                            <span style="display: inline-block; margin-right: 5px;">{{i+1}}.</span> 
                                            <span style="display: inline-block;">{{s.SNm}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                

                <!-- Units -->
                <div class="col-md-12 col-12 col-sm-12" style="background-color: #1f628e08; padding-top: 10px; 
                padding-bottom: 10px; margin-top: 10px; display: none;">
                    <div style="color: #1f628e; font-size: 19px;">
                        <span>Units</span>
                        <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="OpenUnit();"><i class="zmdi zmdi-plus"></i></span> -->
                        <span style="float: right; font-size: 20px; cursor: pointer;"
                            (click)="OpenUnit(productUnitModal);"><i class="zmdi zmdi-plus"></i></span>
                    </div>
                </div>

                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                    <div class="btn-mdlClose brdrRadius3" (click)="goBack();">
                        <i class="fa fa-close"></i> Close
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item (newItemEvent)="getSelectedItem($event)"></app-multiple-select-item>
</ng-template>

<!-- Product Entry -->
<ng-template #mymodal let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-item-entry [BasicData]="BasicData"></app-item-entry>
    </div>
</ng-template>

<!-- Product BOM -->
<ng-template #productBOMModal let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-product-bom [BOMData]="BOMData"></app-product-bom>
    </div>
</ng-template>

<!-- Product Byproduct Entry -->
<ng-template #productByproductModal let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-product-byproducts [ByproductData]="ByproductData"></app-product-byproducts>
    </div>
</ng-template>

<!-- Stages Show -->
<ng-template #productStageModal let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-stage-selection [stageData]="stageData"></app-stage-selection>
    </div>
</ng-template>

<!-- Product Unit -->
<ng-template #productUnitModal let-modal>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-product-units></app-product-units>
    </div>
</ng-template>

<!-- Item Modal -->
<ng-template #selectUnit let-modal>
    <app-product-units></app-product-units>
</ng-template>